import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { LazyImage } from '~/components/LazyImage';
import { contentType } from '~/types';
import { isVideoAsset } from '~/utils';

const propTypes = {
  content: contentType,
  alt: PropTypes.string,
  contentPreviewedId: PropTypes.string,
};

const STORY_PREVIEW_ASPECT_RATIO = 16 / 27;

export const StoryPreviewCard = ({
  content,
  contentPreviewedId,
  alt = 'Story preview',
  ...rest
}) => {
  const [asset] = content.assets || [];
  const isVideo = isVideoAsset(asset);

  const lazyImageProps = {};

  if (!isVideo) {
    lazyImageProps.fallbackSrc = asset?.url;
  }

  return (
    <Box borderRadius="lg" overflow="hidden" {...rest}>
      <LazyImage
        ratio={STORY_PREVIEW_ASPECT_RATIO}
        src={asset?.previewUrl}
        imageProps={{ alt, id: contentPreviewedId }}
        {...lazyImageProps}
      />
    </Box>
  );
};

StoryPreviewCard.propTypes = propTypes;
